module.exports = __webpack_public_path__ + "img/bg.a1e6be04.webp";